import * as React from "react";
import * as S from "@styled";
import { connect } from "react-redux";
import CustomModal from "shared/components/CustomModal";
import { ParameterEditorValue } from "../../../processEditor/model/ParameterEditorValue";
import { ChangeEvent } from "../../../shared/model/Event";
import * as Utilities from "../../../shared/utilities";
import { DispatchType } from "../../../shared/utilities";
import * as RunOnceActions from "../../actions/RunOnceActions";
import { ITriggerParameter } from "../../model/Process";
import { IRunOnceProcessModel } from "../../model/RunOnceDialogState";
import { State } from "../../model/State";

export const RunOnceDialog: React.FC<RunOnceDialogProps> = (props) => {

    const handleInputchange = (id: number, key: string, value: string) => {
        if (props.onInputchange) {
            props.onInputchange(id, key, value);
        }
    };

    if (!props.showRunOnceDialog) {
        return null;
    }

    return (
        <CustomModal
            label="run-once-dialog"
            onClose={props.closeRunOnceDialog}
            shouldCloseOnOverlayClick={true}
            show={true}
            modalTitle={<h2>{FRENDS.Localizations.RunOnce}</h2>}
        >
            {props.runOnceProcessModel.map((p) =>
                <S.FormGroup key={p.id}>
                    <h3 style={{ marginBottom: "10px" }}>{p.processName}</h3>
                    {p.parameters?.map((parameter, idx) => (
                        <ParameterInput
                            key={"parameter-runonce-" + parameter.name}
                            onInputChange={handleInputchange}
                            value={p.triggerData[parameter.name]}
                            parameter={parameter}
                            processId={p.id}
                            autoFocus={idx === 0}
                        />
                    ))}
                </S.FormGroup>
            )}
            <S.FormGroup>
                <S.ButtonGroup $justifyContentEnd={true} gap={10}>
                    <S.Button variant={S.ButtonType.bordered} onClick={props.closeRunOnceDialog}>{FRENDS.Localizations.Cancel}</S.Button>
                    <S.Button onClick={props.onRunOnce}>{FRENDS.Localizations.RunOnce}</S.Button>
                </S.ButtonGroup>
            </S.FormGroup>
        </CustomModal>
    );
};

const ParameterInput: React.FC<IParameterInputProp> = (props) => {

    const handleInputchange = (event: ChangeEvent<HTMLTextAreaElement>) => {
        props.onInputChange(props.processId, props.parameter.name, event.target.value);
    };

    return (
        <S.FormGroup>
            <S.Label title={props.parameter.description}>
                {props.parameter.isSecret ? <i title={FRENDS.Localizations.ParameterEditor_ParameterWillNotBeLogged} className="ci-hide" /> : null}
                {Utilities.Utilities.humanizeLabel(props.parameter.name)}</S.Label>
            <S.TextArea defaultValue={props.value as string} autoFocus={props.autoFocus} onChange={handleInputchange} />
        </S.FormGroup>
    );
};

interface IParameterInputProp {
    parameter: ITriggerParameter;
    value: string | undefined | ParameterEditorValue;
    processId: number;
    onInputChange: (id: number, key: string, value: string) => void;
    autoFocus: boolean;
}

interface RunOnceDialogOwnProps { }

interface RunOnceDialogStateProps {
    showRunOnceDialog?: boolean;
    agentGroupName?: string;
    runOnceProcessModel: IRunOnceProcessModel[];
}
interface RunOnceDialogDispatchProps {
    onInputchange?: (id: number, key: string, value: string) => void;
    onRunOnce?: () => void;
    closeRunOnceDialog: () => void;
}

type RunOnceDialogProps = RunOnceDialogOwnProps & RunOnceDialogStateProps & RunOnceDialogDispatchProps;

const mapStateToProps = (state: State, ownProps: RunOnceDialogOwnProps): RunOnceDialogStateProps => {
    return {
        showRunOnceDialog: state.runOnceDialogState.showRunOnce,
        agentGroupName: state.runOnceDialogState.agentGroup,
        runOnceProcessModel: state.runOnceDialogState.runOnceProcessModel
    };
};

const mapDispatchToProps = (dispatch: DispatchType<State>, ownProps: RunOnceDialogOwnProps): RunOnceDialogDispatchProps => {
    return {
        onInputchange: (id: number, key: string, value: string) => dispatch(RunOnceActions.updateRunOnceParameter(id, key, value)),
        onRunOnce: () => dispatch(RunOnceActions.runOnceWithParameters() as any),
        closeRunOnceDialog: () => dispatch(RunOnceActions.closeRunOnceDialog())
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(RunOnceDialog);
